import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddTransportation from "./Form";
import ViewTransportation from "./View";
import { get, api, del } from "../../../../utils/api";
import Cards from "../../../../Components/Common/Cards";
import ViewTable from "../../../../Components/Common/ViewTable";
import FilterModal from "../../../../Components/Common/FilterModal";
import ActionButtons from "../../../../Components/Common/ActionButtons";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import RailTransportationBulkUploadReview from "./RailTransportationBulkUploadReview";
import BulkUploadSkippedDialog from "../../../../Components/Common/BulkUploadSkippedDialog";
import { useUser } from "../../../../context/AuthContext";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";

const RailTransport = () => {
  const { user } = useUser();
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const [page, setPage] = useState(1);
  const [addData, setAddData] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [filterOrigin, setFilterOrigin] = useState([]);
  const [filterDestination, setFilterDestination] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [errors, setErrors] = useState({
    Date: false,
    industrialProcess: false,
    equipmentType: false,
    industrialEquipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [dataforView, setdataForView] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});

  const [cardData, setCardData] = useState({});
  const tableContainerRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});

  const [excelData, setExcelData] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [matchData, setMatchData] = useState([]);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState([]);
  const [skippedUploadDialog, setSkippedUploadDialog] = useState({
    open: false,
    skippedEntries: [],
    inserted: 0,
    skipped: 0,
  });

  const uploadErrorClose = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(true);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(false);
    setMatchData([]);
    setFormDataBulkUpload([]);
    setSkippedUploadDialog({
      open: false,
      skippedEntries: [],
      inserted: 0,
      skipped: 0,
    });
    fetchData();
  };

  const fetchExcelData = async () => {
    let arr = [
      {
        "S No.": 1,
        "Month (in 01/25 or Jan-25)": "",
        "Transportation Type": "Upstream",
        Origin: "",
        Destination: "",
        "Freight Load (in Tonnes)": "",
        Remark: "",
        Document: "",
      },
      {
        "S No.": 2,
        "Month (in 01/25 or Jan-25)": "",
        "Transportation Type": "Downstream",
        Origin: "",
        Destination: "",
        "Freight Load (in Tonnes)": "",
        Remark: "",
        Document: "",
      },
    ];
    setExcelData(arr);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3.2);
    }
  }, [tableData]);

  const headers = [
    { key: "createdAt", label: "Date", sortable: true, width: "12%" },
    {
      key: "consumptionPeriod",
      label: "Consumption Month",
      sortable: true,
      width: "15%",
    },
    {
      key: "origin",
      label: "Source",
      sortable: true,
      width: "15%",
    },
    {
      key: "destination",
      label: "Destination",
      sortable: true,
      width: "15%",
    },
    {
      key: "freightLoad",
      label: "Freight Load (Tonnes)",
      sortable: true,
      width: "17%",
    },
    {
      key: "distanceCovered",
      label: "Distance Travelled (Km)",
      width: "17%",
      sortable: true,
    },
    // { key: "unit", label: "Vendor Name", sortable: true },
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },

    {
      fieldName: "transportationType",
      title: "Transportation Type",
      placeholder: "Select Travel Type ",
      type: "select",
      // options: ["Upstream","Downstream"],
    },

    {
      fieldName: "origin",
      title: "Source",
      placeholder: "Enter Source",
      type: "String",
      required: true,
    },
    {
      fieldName: "destination",
      title: "Destination",
      placeholder: "Enter Destination",
      type: "String",
      required: true,
    },
    {
      fieldName: "freightLoad",
      title: "Freight Load",
      placeholder: "10000",
      type: "number",
      required: true,
    },
    {
      fieldName: "distanceCovered",
      title: "Distance Travelled",
      placeholder: "Autofetched",
      // type: "number",
      required: true,
    },

    {
      fieldName: "remark",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Consumption Month",
      type: "month",
      key: "consumptionPeriod",
      value: [],
    },
    {
      title: "Source",
      type: "option",
      key: "origin",
      value: filterOrigin,
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: filterDestination,
    },
    {
      title: "Freight Load (Tonnes)",
      type: "limit",
      key: "freightLoad",
      value: ["one", "two"],
    },
  ];

  const fetchFilters = async () => {
    await get(`/scope3/railTransportation/rail/filter`)
      .then((res) => {
        setFilterOrigin(res?.data?.data?.origin);
        setFilterDestination(res?.data?.data?.destination);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/railTransportation/cardData`);

      setCardData({
        mostCommonRoute: [
          res?.data?.data?.mostCommonRoute?.origin,
          res?.data?.data?.mostCommonRoute?.destination,
        ],
        totalLoad: res?.data?.data?.totalFreightLoad,
        totalDistanceTraveled: res?.data?.data?.totalDistanceTraveled,
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setPage(1);
    setCurrentPage(1);
  };
  console.log("pageeeeeeeeee", page);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onResetFilters = () => {
    setFilterObj({}); // Reset the filter object
    fetchData(); // Fetch data without filters
  };

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    // setSelectedPetroleum(petroleum);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedPetroleum(null);
  };

  const handleEdit = (data) => {
    handleMenuClose();
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    handleMenuClose();
    setView(true);
    setAddData(false);
    setdataForView(data?.data);
  };

  const handleDelete = (index) => {
    handleMenuClose();
    setDeleteDialog(true);
    setdataView(index.id);
  };

  const handleDeleteAggree = () => {
    del(`/scope3/railTransportation/delete`, {
      params: {
        Id: dataView, // Pass as query parameter
      },
    })
      .then(async (res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
      })
      .catch((err) => {
        console.log(err);
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async () => {
    let filter = { ...filterObj };
    if (
      filter.freightLoad &&
      filter.freightLoad.min &&
      filter.freightLoad.max
    ) {
      filter.minLoad = parseFloat(filterObj.freightLoad.min);
      filter.maxLoad = parseFloat(filterObj.freightLoad.max);
    }

    if (filter.createdAt?.start) {
      filter.startDate = filter.createdAt.start;
    }
    if (filter.createdAt?.end) {
      filter.endDate = filter.createdAt.end;
    }

    if (filter.consumptionPeriod?.start) {
      filter.startMonth = filter.consumptionPeriod.start;
    }
    if (filter.consumptionPeriod?.end) {
      filter.endMonth = filter.consumptionPeriod.end;
    }

    const queryParams = new URLSearchParams({
      ...filter,
      page: currentPage,
      limit: 10,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();
    await get(`/scope3/railTransportation/get?${queryParams}`)
      .then((res) => {
        let arr = res?.data?.data?.map((item) => {
          return {
            createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }),
            origin: item?.origin,
            destination: item.destination,
            freightLoad: item?.freightLoad,
            distanceCovered: item?.distanceCovered,
            consumptionMonth: `${item.consumptionPeriod.month}-${item.consumptionPeriod.year}`,
            action: "View",
            id: item?._id,
            data: item,
          };
        });
        setTableData(arr);
        setPageSize(res.data.totalPages);
        fetchCardData();
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
    // fetchData()
  }, [currentPage, rowsPerPage, sortConfig, filterObj]);

  // default filters to apply

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setDrawerFilterOpen(false);
    // setErrors({ Date: false, Role: false });
  };

  // let bannerData = [
  //   {
  //     title: "Most Common Rail Route",
  //     description: cardData?.mostCommonRoute ?? [],
  //   },
  //   {
  //     title: "Total Freight Load (Tonnes)",
  //     description: `${cardData?.totalLoad?.toFixed(3)} Tonnes`,
  //   },
  //   {
  //     title: "Total Distance Travelled",
  //     description: `${cardData?.totalDistanceTraveled?.toFixed(3)} Km`,
  //   },
  // ];

  let bannerData = [
    {
      title: "Most Common Rail Route",
      description:
        cardData?.mostCommonRoute?.length > 0
          ? cardData.mostCommonRoute.join(" | ")
          : "N/A",
    },
    {
      title: "Total Freight Load (Tonnes)",
      description: cardData?.totalLoad ? cardData.totalLoad : 0,
      unit: "Tonnes",
    },
    {
      title: "Total Distance Travelled",
      description: cardData?.totalDistanceTraveled
        ? cardData.totalDistanceTraveled
        : 0,
      unit: "Km",
    },
  ];

  const openModal = (type, dataForEdit = null) => {
    if (type === "add") {
      setEditModal(false);
      setEditData(null);
      setAddData(true);
    } else if (type === "edit") {
      setAddData(false);
      setEditModal(true);
      setEditData(dataForEdit);
    }
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleClose = () => {
    setdataView({});
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <AddTransportation
        addData={addData}
        setAddData={setAddData}
        setdataView={setdataView}
        SelectedData={dataView}
        fetchData={fetchData}
        inputData={inputData}
        id={dataView ? dataView._id : ""}
        addUrl={`${api}/scope3/railTransportation/add`}
        updateUrl={`${api}/scope3/railTransportation/update`}
        setsnackOpen={setsnackOpen}
        handleModalClose={handleClose}
      />
      <ViewTransportation
        view={view}
        setView={setView}
        selectedData={dataforView}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      <Cards data={bannerData} title={" Rail Transportation"} />
      {/* {deleteDialog && (
        <Dialog open={deleteDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteAggree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: dataView,
            url: `${api}/scope3/railTransportation/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        onUploadClick={() => setBulkUploadModal(true)}
        filterObj={filterObj}
      />

      <ViewTable
        tableContainerRef={tableContainerRef}
        isShortContent={isShortContent}
        title={"Rail Transportation"}
        headers={headers}
        // data={tableData}
        data={tableData ?? []}
        onSort={handleSort}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        totalPages={totalPages}
        sortConfig={sortConfig}
        onMenuClick={handleMenuClick}
        page={currentPage}
        count={pageSize}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "120px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Logs
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
          <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
          <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Delete
        </MenuItem>
      </Menu>

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          setsnackOpen={setsnackOpen}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"rail transportation"}
          url={"/scope3/railTransportation/bulkupload"}
          setMatchData={setMatchData}
          setFormDataBulkUpload={setFormDataBulkUpload}
          matchedKey="railTransportationStatusList"
          errorClose={uploadErrorClose}
          setBulkUploadModal={setBulkUploadModal}
        />
      )}

      {bulkUploadTable && (
        <RailTransportationBulkUploadReview
          bulkUploadTable={bulkUploadTable}
          matchData={matchData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setsnackOpen={setsnackOpen}
          bulkUploadUrl="/scope3/railTransportation/jsonupload"
          onClose={() => {
            setBulkUploadTable(false);
            setMatchData([]);
            setFormDataBulkUpload([]);
            fetchData();
          }}
          onConfirm={(data) => {
            setBulkUploadTable(false);
            setMatchData([]);
            setFormDataBulkUpload([]);
            fetchData();
            fetchCardData();

            const skippedEntries = data?.skippedEntries;
            const hasSkipped =
              Array.isArray(skippedEntries) && skippedEntries.length > 0;
            const inserted = Number(data?.inserted ?? 0);
            const skipped = Number(data?.skipped ?? 0);

            if (hasSkipped) {
              setSkippedUploadDialog({
                open: true,
                skippedEntries,
                inserted,
                skipped,
              });
            }
          }}
        />
      )}

      <BulkUploadSkippedDialog
        open={skippedUploadDialog.open}
        skippedEntries={skippedUploadDialog.skippedEntries}
        inserted={skippedUploadDialog.inserted}
        skipped={skippedUploadDialog.skipped}
        downloadFileName="rail_transportation_skipped"
        onClose={() =>
          setSkippedUploadDialog({
            open: false,
            skippedEntries: [],
            inserted: 0,
            skipped: 0,
          })
        }
        // onDownload={(rows) => setExcelData(rows)}
      />
    </Box>
  );
};

export default RailTransport;
